// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/preview-outkast.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/preview-skwiz.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/preview-teenage-euthanasia.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/preview-teenage-euthanasia-backdrop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/preview-kris-kelly.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/preview-ewonee.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/preview-sam-evian.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/preview-city-island.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/preview-city-island-backdrop.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    margin: 120px auto;
}

.tabs h2 {
    color: #000;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 48px */
    margin-bottom: 24px;
}

.tabs .tabs-container {
    display: flex;
    gap: 40px;
    justify-content: center;
    margin-bottom: 64px;
}

.tab-text {
    color: #000;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 18px */
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
}

.tiles {
    display: grid;
    align-content: center;
    justify-content: center;
    align-items: center;
    justify-items: start;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 12px;
    row-gap: 24px;
    grid-auto-rows: minmax(100px, auto);
}

.tile {
    width: calc((100vw - 228px) / 4);
    color: white;
    height: calc((100vw - 228px) / 2.666);
    position: relative;
}

.tile-background {
    height: 100%;
    width: 100%;
    background: linear-gradient(0deg, black, transparent, transparent);
    background-size: cover;
    transition: transform 0.25s;
}

#PreviewOutkast.tile-background {
    background:  linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_0___}), black;
    background-size: cover;
}

#PreviewSkwiz.tile-background {
    background:  linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_1___}), black;
    background-size: cover;
}

#PreviewTeenageEuthanasia.tile-background {
    background: linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_2___}), url(${___CSS_LOADER_URL_REPLACEMENT_3___}), black;
    background-size: cover;
}

#PreviewKrisKelly.tile-background {
    background: linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_4___}), black;
    background-size: cover;
}

#PreviewEwonee.tile-background {
    background: linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_5___}), black;
    background-size: cover;
}

#PreviewSamEvian.tile-background {
    background: linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_6___}), #433EA3;
    background-size: cover;
}

#PreviewCityIsland.tile-background {
    background: linear-gradient(0deg, black, transparent, transparent), url(${___CSS_LOADER_URL_REPLACEMENT_7___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___}), #433EA3;
    background-size: cover;
}

.tile-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;

    position: absolute;
    bottom: 32px;
    margin: 0 auto;
    left: 0;
    right: 0;
}

.tile:hover {
    cursor: pointer;
}

.tile:hover .tile-background {
    transform: scale(1.075);
}


@media screen and (max-width: 1439px){
    .tiles {
        grid-template-columns: repeat(3, 1fr);
    }
    
    .tile {
        width: calc((100vw - 216px) / 3);
        height: calc((100vw - 216px) / 2);
    }
}

@media screen and (max-width: 1000px){

    
    .tiles {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .tile {
        width: calc((100vw - 140px) / 2);
        height: calc((100vw - 140px) / 1.333);
    }
}

@media screen and (max-width: 680px){
    .tiles {
        grid-template-columns: repeat(1, 1fr);
    }
    
    .tile {
        width: calc((100vw - 128px));
        height: calc((100vw - 128px) / 0.666);
    }

    .tabs .tabs-container {
        justify-content: space-around;
        gap: inherit;
    }
}

@media screen and (max-width: 448px) {
    .tile {
        width: calc((100vw - 96px));
        height: calc((100vw - 96px) / 0.666);
    }

    .tabs {
        margin: 96px auto;
    }

    .tabs h2 {
        font-size: 24px;
        margin-bottom: 16px;
    }

    .tab-text {
        font-size: 10px;
    }
}

/* 
Notes Tile Sizes

tile width is window width - margins   - the column gaps divided by number of tiles
tile width = 100vw         - (96 + 96) - (12 + 12 + 12) / 4

4 Tiles
tile width = (100vw - (96 + 96) - (12 + 12 + 12)) / 4
tile width = (100vw - 228px) / 4

3 Tiles
tile width = (100vw - (96 + 96) - (12 + 12)) / 3
tile width = (100vw - 216px) / 3

2 Tiles
tile width = (100vw - (64 + 64) - 12) / 2
tile width = (100vw - 140px) / 2

1 Tile
tile width = (100vw - (64 + 64))
tile width = (100vw - 128px)

*/`, "",{"version":3,"sources":["webpack://./src/components/tabs/tabs.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kEAAkE;IAClE,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,mHAA+G;IAC/G,sBAAsB;AAC1B;;AAEA;IACI,mHAA6G;IAC7G,sBAAsB;AAC1B;;AAEA;IACI,2JAAkL;IAClL,sBAAsB;AAC1B;;AAEA;IACI,kHAAiH;IACjH,sBAAsB;AAC1B;;AAEA;IACI,kHAA6G;IAC7G,sBAAsB;AAC1B;;AAEA;IACI,oHAAkH;IAClH,sBAAsB;AAC1B;;AAEA;IACI,6JAAsK;IACtK,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;;IAET,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,gCAAgC;QAChC,iCAAiC;IACrC;AACJ;;AAEA;;;IAGI;QACI,qCAAqC;IACzC;;IAEA;QACI,gCAAgC;QAChC,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,4BAA4B;QAC5B,qCAAqC;IACzC;;IAEA;QACI,6BAA6B;QAC7B,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,oCAAoC;IACxC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC","sourcesContent":[".tabs {\n    margin: 120px auto;\n}\n\n.tabs h2 {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 48px */\n    margin-bottom: 24px;\n}\n\n.tabs .tabs-container {\n    display: flex;\n    gap: 40px;\n    justify-content: center;\n    margin-bottom: 64px;\n}\n\n.tab-text {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%; /* 18px */\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n\n.tiles {\n    display: grid;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    justify-items: start;\n    grid-template-columns: repeat(4, 1fr);\n    column-gap: 12px;\n    row-gap: 24px;\n    grid-auto-rows: minmax(100px, auto);\n}\n\n.tile {\n    width: calc((100vw - 228px) / 4);\n    color: white;\n    height: calc((100vw - 228px) / 2.666);\n    position: relative;\n}\n\n.tile-background {\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(0deg, black, transparent, transparent);\n    background-size: cover;\n    transition: transform 0.25s;\n}\n\n#PreviewOutkast.tile-background {\n    background:  linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-outkast.gif'), black;\n    background-size: cover;\n}\n\n#PreviewSkwiz.tile-background {\n    background:  linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-skwiz.gif'), black;\n    background-size: cover;\n}\n\n#PreviewTeenageEuthanasia.tile-background {\n    background: linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-teenage-euthanasia.gif'), url('./assets/preview-teenage-euthanasia-backdrop.png'), black;\n    background-size: cover;\n}\n\n#PreviewKrisKelly.tile-background {\n    background: linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-kris-kelly.gif'), black;\n    background-size: cover;\n}\n\n#PreviewEwonee.tile-background {\n    background: linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-ewonee.gif'), black;\n    background-size: cover;\n}\n\n#PreviewSamEvian.tile-background {\n    background: linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-sam-evian.gif'), #433EA3;\n    background-size: cover;\n}\n\n#PreviewCityIsland.tile-background {\n    background: linear-gradient(0deg, black, transparent, transparent), url('./assets/preview-city-island.gif'), url('./assets/preview-city-island-backdrop.png'), #433EA3;\n    background-size: cover;\n}\n\n.tile-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 48px;\n\n    position: absolute;\n    bottom: 32px;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n}\n\n.tile:hover {\n    cursor: pointer;\n}\n\n.tile:hover .tile-background {\n    transform: scale(1.075);\n}\n\n\n@media screen and (max-width: 1439px){\n    .tiles {\n        grid-template-columns: repeat(3, 1fr);\n    }\n    \n    .tile {\n        width: calc((100vw - 216px) / 3);\n        height: calc((100vw - 216px) / 2);\n    }\n}\n\n@media screen and (max-width: 1000px){\n\n    \n    .tiles {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .tile {\n        width: calc((100vw - 140px) / 2);\n        height: calc((100vw - 140px) / 1.333);\n    }\n}\n\n@media screen and (max-width: 680px){\n    .tiles {\n        grid-template-columns: repeat(1, 1fr);\n    }\n    \n    .tile {\n        width: calc((100vw - 128px));\n        height: calc((100vw - 128px) / 0.666);\n    }\n\n    .tabs .tabs-container {\n        justify-content: space-around;\n        gap: inherit;\n    }\n}\n\n@media screen and (max-width: 448px) {\n    .tile {\n        width: calc((100vw - 96px));\n        height: calc((100vw - 96px) / 0.666);\n    }\n\n    .tabs {\n        margin: 96px auto;\n    }\n\n    .tabs h2 {\n        font-size: 24px;\n        margin-bottom: 16px;\n    }\n\n    .tab-text {\n        font-size: 10px;\n    }\n}\n\n/* \nNotes Tile Sizes\n\ntile width is window width - margins   - the column gaps divided by number of tiles\ntile width = 100vw         - (96 + 96) - (12 + 12 + 12) / 4\n\n4 Tiles\ntile width = (100vw - (96 + 96) - (12 + 12 + 12)) / 4\ntile width = (100vw - 228px) / 4\n\n3 Tiles\ntile width = (100vw - (96 + 96) - (12 + 12)) / 3\ntile width = (100vw - 216px) / 3\n\n2 Tiles\ntile width = (100vw - (64 + 64) - 12) / 2\ntile width = (100vw - 140px) / 2\n\n1 Tile\ntile width = (100vw - (64 + 64))\ntile width = (100vw - 128px)\n\n*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
